module.exports = __webpack_public_path__ + "img/icon-share.03ffdb4d.svg";